import apiClient from "./apiClient";
import { MonthlySummaryResponse } from "../types/monthlySummaryTypes";

/**
 * Obtiene el Resumen Mensual de un proyecto.
 *
 * El backend deriva el periodo a partir de la fecha de corte (día 1 del mes de
 * esa fecha hasta la fecha misma), así que acá solo se envía la fecha.
 *
 * @param idProject Identificador del proyecto.
 * @param date      Fecha de corte en formato YYYY-MM-DD. No puede ser futura.
 */
export const getMonthlySummary = async (
    idProject: number,
    date: string
): Promise<MonthlySummaryResponse> => {
    try {
        const response = await apiClient.get(`/monthly-summary/${idProject}`, {
            params: { date },
        });
        return response.data;
    } catch (error) {
        console.error("Error al obtener el Resumen Mensual: ", error);
        throw error;
    }
};
